export default {
  selectPassenger,
  onRouteIdChange,
  applyFlightsToPassengers,
  findPassenger,
};

function selectPassenger (id) {
  let { flights, passengers, routeId } = this.state;
  let selectedPassenger;
  let passengerExist = false;
  let isCheckedOnFirstRoute = false;
  passengers.find(passenger => {
    if (passenger.id === id) {
      passenger.selected = !passenger.selected;
      selectedPassenger = passenger;
    }
  });
  flights.find((flight, index) => {
    if (
      (index === 0 && flight.routeId === routeId) ||
      isCheckedOnFirstRoute ||
      flight.routeId === routeId
    ) {
      flight.passengers.find(passenger => {
        if (passenger.id === id) {
          passenger.selected = isCheckedOnFirstRoute ?
            selectedPassenger.selected :
            !passenger.selected;
          passengerExist = true;
        }
      });

      if (index === 0 && flight.routeId === routeId) isCheckedOnFirstRoute = true;

      if (!passengerExist && selectedPassenger) {
        let newFlightPassenger = {
          id: selectedPassenger.id,
          selected: selectedPassenger.selected,
        };
        flight.passengers.push(newFlightPassenger);
      }
    }
  });

  this.setState({ passengers, flights });
  this.props.actions.updateFlights(flights);
}

function onRouteIdChange (props) {
  let { flights, passengers, routeId, isFetching } = props;
  let stateFlights = this.state.flights;
  let passengersLoaded = passengers && passengers.length;
  let flightsLoaded = flights && flights.length;
  if (!isFetching && passengersLoaded && flightsLoaded) {
    if (stateFlights && stateFlights.length) {
      passengers = applyFlightsToPassengers(stateFlights, routeId, passengers);
      flights = stateFlights;
    } else {
      passengers = applyFlightsToPassengers(flights, routeId, passengers);
    }
    this.setState({ flights, passengers, routeId });
  } else {
    this.setState({ routeId });
  }
}

function applyFlightsToPassengers (flights, routeId, passengers) {
  let noFlights = !flights || !flights.length;
  if (noFlights) {
    return passengers;
  }

  if (!passengers || !passengers.length) {
    return [];
  }

  flights.find(flight => {
    if (flight.routeId === routeId) {
      passengers.find(passenger => {
        if (!flight.passengers || !flight.passengers.length) {
          return passengers;
        }
        let flightPassenger = flight.passengers.find(fPassenger => fPassenger.id === passenger.id);
        passenger.selected = (flightPassenger && flightPassenger.selected) || false;
        passenger.seatId = flightPassenger && flightPassenger.seatId ? flightPassenger.seatId : '';
        passenger.seatPreview =
          flightPassenger && flightPassenger.seatPreview ? flightPassenger.seatPreview : '';
        passenger.seatAssigmentId =
          flightPassenger && flightPassenger.seatAssigmentId ? flightPassenger.seatId : '';
      });
    }
  });

  return passengers;
}

function findPassenger (search) {
  const { passengers } = this.props;

  search = search.toLowerCase();

  this.setState({
    filteredPassengers: passengers.filter(
      passenger =>
        `${passenger.firstName} ${passenger.lastName}`.toLowerCase().indexOf(search) !== -1
    ),
  });
}



// WEBPACK FOOTER //
// ./src/containers/passengersList/PassengersListController.js